// Note
// This file requires some props:
// 1. "classname"------> It is a string which displays class name on header
// 2. "breadCrumb" ------> It takes array of strings to display breadcrumbs in header
// 3. "searchTextField" -----> It takes BOOLEAN to display Search textfield on header
// 4. "searchData" ------> It gives you the data which is entered in the search textfield
// 5. "openClassesDrawer" ------> the function is triggered if we click on the down arrow for changing the class
// 6. "hideClassSwitcher" -------> Boolean; if true it will hide class switch button

import React, { Component } from "react";

import classes from "./Layout_Dashboard.module.css";
import { withTranslation } from 'react-i18next';

// Icons
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchIcon from "@material-ui/icons/Search";
// Material Ui
import { TextField, InputAdornment } from "@material-ui/core";

class LayoutDashboard extends Component {
  searchInputChangeHandler = (event) => {
    this.props.searchData(event.target.value);
    // this.setState((prevState) => ({
    //   ...prevState,
    //   searchTextField: event.target.value,
    // }));
  };
  render() {
    const { t } = this.props;
    return (
      <>
        {/* Container */}
        <div className={classes.Container}>
          {/* Title Bar */}
          <div className={classes.TitleBar}>
            {/* Left Block */}
            <div className={classes.TitleBar_LeftBlock}>
              {/* Class Name */}
              <p className={classes.TitleBar_ClassName}>
                {this.props.classname ? this.props.classname : t("No Class Found")}{" "}
              </p>
              {/* <span
                onClick={() => {
                  this.props.openClassesDrawer();
                }}
              > */}
              {this.props.hideClassSwitcher ? (
                <></>
              ) : (
                <ExpandMoreIcon
                  onClick={() => {
                    this.props.openClassesDrawer();
                  }}
                  style={{ marginLeft: "8px", cursor: "pointer" }}
                  className="TextDarkGrey"
                />
              )}

              {/* </span> */}
              {/* Class Name Ends */}
              {/* BreadCrumbs */}
              <div className={classes.BreadCrumb}>
                {this.props.breadCrumb && this.props.breadCrumb.length ? (
                  this.props.breadCrumb.map((breadCrumbItem) => (
                    <span className={classes.BreadCrumbItem}>
                      <ArrowRightIcon className="TextDarkGrey" />
                      <span
                        style={{ marginLeft: "10px" }}
                        className="TextDarkGrey"
                      >
                        {t(breadCrumbItem)}
                      </span>
                    </span>
                  ))
                ) : (
                    <></>
                  )}
              </div>
              {/* BreadCrumbs Ends */}
            </div>
            {/* Left Block */}
            {/* Right BLock Ends */}
            <div>
              {this.props.searchTextField ? (
                <TextField
                  // value={this.state.searchTextField}
                  onChange={this.searchInputChangeHandler}
                  variant="outlined"
                  size="small"
                  placeholder={t("Search ...")}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon style={{ color: "#BFC7D2" }} />
                      </InputAdornment>
                    ),
                    style: {
                      height: 40,
                      width: 250,
                      backgroundColor: "rgba(52, 73, 94, 0.05)",
                      color: "rgba(52, 73, 94, 0.75)",
                    },
                  }}
                />
              ) : (
                  <></>
                )}
            </div>
            {/* Right BLock Ends*/}
          </div>
          {/* Title Bar Ends */}
          {/* Body */}
          <div className={classes.Body}>{this.props.children}</div>
          {/* Body Ends*/}
        </div>
        {/* Container Ends */}
      </>
    );
  }
}

export default withTranslation()(LayoutDashboard);
